import { yupResolver } from '@hookform/resolvers/yup'
import { CountryData } from 'country-codes-list'
import { isEqual } from 'lodash-es'
import { FC, useEffect } from 'react'
import { Controller, useForm } from 'react-hook-form'
import { isValidPhoneNumber } from 'react-phone-number-input'
import { useNavigate } from 'react-router-dom'
import * as yup from 'yup'

import { PhoneNumberCountry } from '@/components/phone-number-country'
import { Button } from '@/components/ui'
import { getTranslation } from '@/account/services/auth'
import translate from '@/core/services/translate'

interface LoginPhoneFormProps {
  submitPhone: (phone: string) => void
}

export const LoginPhoneForm: FC<LoginPhoneFormProps> = ({ submitPhone }) => {
  const navigation = useNavigate()
  const language = getTranslation()

  useEffect(() => {
    setValue('phoneNumberCountry', {
      countryCode: 'RO',
      countryCodeValue: '+40',
      phone: '',
    })
  }, [])

  const schema = yup.object().shape({
    phoneNumberCountry: yup.object().shape({
      countryCode: yup.string().required(),
      countryCodeValue: yup.string().required(),
      phone: yup
        .string()
        .when('countryCallingCode', (countryCallingCode) => {
          if (countryCallingCode) {
            return yup
              .string()
              .test(
                'Valid phone number',
                translate(language.value, 'common.validPhoneNumber'),
                (value, context) => {
                  const country: CountryData = context.parent.countryCodeValue
                  if (value) return isValidPhoneNumber(`${country}${value}`)
                  return false
                },
              )
          } else {
            return yup.string().required('Please Select Country!')
          }
        })
        .required(),
    }),
  })

  type AuthPhoneValues = yup.InferType<typeof schema>

  const {
    handleSubmit,
    control,
    register,
    setValue,
    formState: { errors },
  } = useForm<AuthPhoneValues>({
    mode: 'onChange',
    resolver: yupResolver<AuthPhoneValues>(schema),
  })

  const submit = (data: AuthPhoneValues) => {
    const phone = isEqual(data.phoneNumberCountry.phone[0], '0')
      ? data.phoneNumberCountry.phone.slice(1)
      : data.phoneNumberCountry.phone
    submitPhone(`${data.phoneNumberCountry.countryCodeValue}${phone}`)
  }

  return (
    <form onSubmit={handleSubmit(submit)} className="space-y-7 w-full">
      <Controller
        control={control}
        render={({ field }) => (
          <PhoneNumberCountry
            value={{
              countryCode: field?.value?.countryCode,
              countryCodeValue: field?.value?.countryCodeValue,
              phoneNumber: field?.value?.phone || '',
            }}
            onChange={(value) => {
              field.onChange({
                countryCode: value.countryCode,
                countryCodeValue: value.countryCodeValue,
                phone: value.phoneNumber || '',
              })
            }}
            error={errors.phoneNumberCountry?.phone?.message}
          />
        )}
        name="phoneNumberCountry"
      />
      <Button type="submit" className="w-full">
        {translate(language.value, 'buttons.continue')}
      </Button>
      <p
        className="text-body-medium text-center text-monochrome-2 mt-4"
        dangerouslySetInnerHTML={{
          __html: translate(language.value, 'privacyText'),
        }}
      />
    </form>
  )
}
